import React, { useRef, useState, useEffect } from "react";
import moment from "moment";
import {
	TwitterShareButton,
	FacebookShareButton,
	WhatsappShareButton,
	LinkedinShareButton,
	EmailShareButton
} from "react-share";
import Image from "next/image.js";
import { theme, websiteColors } from "../themes/Theme.js";
import { ticketType } from "../config/constants.js";

const EventCard = ({ event }) => {
	const startDate = event.event_start_timestamp || event.start_date;

	const dateFormatOne = startDate => {
		const newStartDate = moment.utc(startDate).local().format("DD MMM, YYYY");
		return newStartDate.toString();
	};

	const startTime = startDate => {
		return moment.utc(startDate).local().format("h:mm A");
	};

	const city = event.city;
	const country = event.country;

	const [shareClick, setShareClick] = useState(false);
	const wrapperRef = useRef(null);

	const toggleShareOptions = () => {
		return shareClick ? `row share-options p-0 pb-3 px-1` : `d-none`;
	};

	const handleOutsideClick = e => {
		if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
			setShareClick(false);
		}
	};

	useEffect(() => {
		if (shareClick) {
			document.addEventListener("mousedown", handleOutsideClick);
		} else {
			document.removeEventListener("mousedown", handleOutsideClick);
		}
		return () => document.removeEventListener("mousedown", handleOutsideClick);
	}, [shareClick]);

	const shareText = `I'm excited to join ${event.event_name} happening on ${moment(startDate).format("MMMM Do, YYYY")}, organized through KonfHub. Don't miss your chance to attend!\n`;
	const event_url = `\n${event.event_url}`;

	const checkWebsite = () => {
		return event_url;
	};

	return (
		<div
			ref={wrapperRef}
			className="col-lg-4 cursor-pointer col-md-6 font-figtree col-sm-6 mb-4 d-flex px-0 px-md-2"
		>
			<div
				onClick={() => window.open(event.event_url, "_blank")}
				className="event-card d-flex flex-column gap-4"
				style={{ width: "100%" }}
			>
				<img
					src={event.featured_poster ?? event.event_poster_url}
					className="card-img-top"
					alt={event.event_name}
					style={{
						width: "100%",
						minHeight: "148px",
						height: "100%",
						objectFit: "cover"
					}}
				/>
				<div className="d-flex flex-column">
					<div className="d-flex flex-column justify-content-between">
						<div className="d-flex justify-content-between">
							<h5 style={{ maxWidth: "305px" }} className="card-title">
								{event.event_name}
							</h5>
							<div style={{ position: "relative" }} className="d-flex gap-2">
								<div
									style={{ cursor: "pointer" }}
									className="share-icon relative"
									onClick={e => {
										e.stopPropagation();
										setShareClick(prev => !prev);
									}}
								>
									<img
										style={{
											height: "16px",
											width: "16px",
											objectFit: "contain"
										}}
										src="https://d2nnrpx7gk2my2.cloudfront.net/files/67050154fd6732000864a9e3/share-07.svg"
										alt="share icon"
										className="icons share-event"
									/>
								</div>
								{shareClick && (
									<div
										className={toggleShareOptions()}
										onClick={e => e.stopPropagation()}
									>
										<div className="col-12 pt-1 mb-2">
											<span>Share Via</span>
										</div>
										<div className="col-12 h-75 d-flex justify-content-between px-2">
											<EmailShareButton
												subject="New Event - Konfhub Technologies"
												body={shareText}
												url={checkWebsite()}
											>
												<img
													className="share-icons"
													src="https://d2nnrpx7gk2my2.cloudfront.net/files/671b72b181b8080008f1cc5b/mail.svg"
													alt="Email"
												/>
											</EmailShareButton>
											<WhatsappShareButton
												title={shareText}
												url={checkWebsite()}
											>
												<img
													className="share-icons"
													src="https://d2nnrpx7gk2my2.cloudfront.net/files/671b72b381b8080008f1cc5d/whatsapp.svg"
													alt="Whatsapp"
												/>
											</WhatsappShareButton>
											<FacebookShareButton
												quote={shareText}
												url={checkWebsite()}
											>
												<img
													className="share-icons"
													src="https://d2nnrpx7gk2my2.cloudfront.net/files/671b72b781b8080008f1cc63/facebook.svg"
													alt="Facebook"
												/>
											</FacebookShareButton>
											<TwitterShareButton
												title={shareText}
												url={checkWebsite()}
											>
												<img
													className="share-icons"
													src="https://d2nnrpx7gk2my2.cloudfront.net/files/671b72b581b8080008f1cc5f/X.svg"
													alt="Twitter"
												/>
											</TwitterShareButton>
											<LinkedinShareButton
												title={shareText}
												url={checkWebsite()}
											>
												<img
													className="share-icons"
													src="https://d2nnrpx7gk2my2.cloudfront.net/files/671b72b981b8080008f1cc65/linkedin.svg"
													alt="Linkedin"
												/>
											</LinkedinShareButton>
										</div>
									</div>
								)}
								{/* <img style={{ height: "16px", width: "16px", objectFit: "contain" }} src="https://d2nnrpx7gk2my2.cloudfront.net/files/6708fe8aa7d5dd0008561eae/heart.svg" alt="heart icon" className="icons d-block d-sm-none" /> */}
							</div>
						</div>
						<div>
							<ul className="list-unstyled">
								<li>
									<img
										style={{
											height: "16px",
											marginBottom: "2px",
											width: "16px",
											objectFit: "contain",
											borderRadius: "8px"
										}}
										src="https://d2nnrpx7gk2my2.cloudfront.net/files/67050400665ab60009478ec7/calendar.svg"
										alt="calendar icon"
									/>
									<span className="list-item-txt">
										{startDate && dateFormatOne(startDate)}
									</span>
								</li>
								{city ? (
									<li>
										<img
											style={{
												height: "16px",
												marginBottom: "2px",
												width: "16px",
												objectFit: "contain",
												borderRadius: "8px"
											}}
											src="https://d2nnrpx7gk2my2.cloudfront.net/files/6705045d665ab60009478ec9/marker-pin-01.svg"
											alt="location icon"
										/>
										<span className="list-item-txt">{`${city}${country ? `, ${country}` : ""}`}</span>
									</li>
								) : (
									<li>
										<img
											style={{
												height: "16px",
												marginBottom: "2px",
												width: "16px",
												objectFit: "contain",
												borderRadius: "8px"
											}}
											src="https://d2nnrpx7gk2my2.cloudfront.net/files/67336b4954cce80008362db9/online(1).svg"
											alt="location icon"
										/>
										<span className="list-item-txt">Online</span>
									</li>
								)}
							</ul>
							<p className="card-price">
								{event.events_page && event.starting_price != null
									? event.is_free
										? ticketType["free"]
										: `Starts at ₹${event.starting_price}`
									: event.is_free
										? ticketType["free"]
										: ticketType["paid"]}
							</p>
						</div>
					</div>
				</div>
			</div>
			<style jsx>
				{`
					.event-card {
						border: 1px solid #d9d9d9;
						border-radius: 8px;
						transition: transform 0.2s ease;
						display: flex;
						flex-direction: column;
						height: 100%;
						padding: 16px;
						cursor: pointer;
					}

					.event-card:hover {
						//transform: translateY(-5px);
					}

					.event-card .card-img-top {
						object-fit: contain;
						border-radius: 8px;
						border: 1px solid #d9d9d9;
					}

					.event-card .card-body {
						padding: 16px;
						flex-grow: 1;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
					}

					.event-card .card-title {
						font-size: 20px;
						font-weight: 600;
						color: ${websiteColors[theme].primaryWebsiteTheme};
						line-height: 24px;
						height: 48px;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.event-card .list-unstyled {
						padding: 0;
						margin: 10px 0;
						font-size: 14px;
						color: #666;
					}

					.event-card .list-unstyled li {
						margin-bottom: 7px;
					}

					.event-card .card-price {
						font-size: 14px;
						//font-weight: 600;
						line-height: 24px;
						color: ${websiteColors[theme].primaryWebsiteTheme};
						margin-top: 10px;
					}
					button:focus,
					select:focus,
					textarea:focus {
						box-shadow: 0px 0px 0px !important;
					}

					.list-item-txt {
						font-size: 14px;
						font-weight: 500;
						color: #525252;
						line-height: 21px;
						margin-left: 6px;
					}
					.share-options {
						position: absolute;
						right: 12px;
						bottom: 65px;
						width: 180px;
						background: #fff;
						border-radius: 10px;
						box-shadow: 0px 4px 100px 0px rgba(0, 0, 0, 0.25);
						z-index: 100;
					}
					.share-options span {
						font-size: 12px;
					}
					.share-box {
						box-sizing: border-box;
						width: auto;
						height: 41px;
						background: #fff;
						cursor: pointer;
						border: 1px solid #572148;
						border-radius: 50px;
					}

					@media (max-width: 768px) {
						.event-card img {
							// height: 120px;
						}
					}
					@media (max-width: 1200px) {
						.card-title {
							max-width: 218px !important;
						}
					}
				`}
			</style>
		</div>
	);
};

export default EventCard;
